document.addEventListener('DOMContentLoaded', (event) => {

  const sliderWithText = new Swiper('.slider-with-text-slider', {
    spaceBetween: 20,
    loop: true,
    navigation: {
      prevEl: '.slider-with-text-button-prev',
      nextEl: '.slider-with-text-button-next',
    },
    slidesPerView: 1.5,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });

  const swiper = new Swiper('.products-wrap', {
    spaceBetween: 0,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
    slidesPerView: 2,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  });

  const gallerySlider = new Swiper ('.gallery-slider', {
    spaceBetween: 0,
    loop: true,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 2,
      },
    },
  })
  
  const products_on_page = document.getElementById('product-grid');
  let next_url;
  if (products_on_page) {
    next_url = products_on_page.dataset.nextUrl;
  }
  console.log(next_url);

  const load_more_btn = document.querySelector('.load-more_btn');
  const load_more_spinner = document.querySelector('.load-more_spinner');

  async function getNextPage() {
    try {
      let res = await fetch(next_url);
      return await res.text();
    } catch (error) {
      console.log(error);
    }
  }

  async function loadMoreProducts() {
    console.log('active');
    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'block';
    let nextPage = await getNextPage();

    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

    load_more_spinner.style.display = 'none';

    const productgrid = nextPageDoc.getElementById('product-grid');
    const new_products = productgrid.querySelectorAll('.grid__item');
    const new_url = productgrid.dataset.nextUrl;
    if (new_url) {
      load_more_btn.style.display = 'block';
    }
    next_url = new_url;
    for (let i = 0; i < new_products.length; i++) {
      products_on_page.appendChild(new_products[i]);
    }
  }

  if(load_more_btn) {
    load_more_btn.addEventListener('click', loadMoreProducts); 
  }
});




let toggles = document.querySelectorAll('.product-description-toggle');
let tabs = document.querySelectorAll('.product-description-tab');
if(toggles) {
  toggles.forEach(el => {
    el.addEventListener('click', () => {
      toggles.forEach(element => {
        element.classList.remove('active');
      });
      el.classList.add('active');

      if(tabs) {
        tabs.forEach(element => {
          let dataId = element.getAttribute('data-id');
          if(el.id == dataId) {
            element.classList.add('active');
          } else {
            element.classList.remove('active'); 
          }
        })
      }
    })
  })
}

let modals_toggles = document.querySelectorAll('.product-modals-toggle');
let modals_tabs = document.querySelectorAll('.product-modal');
if(modals_toggles) {
  modals_toggles.forEach(el => {
    el.addEventListener('click', () => {
      if(modals_tabs) {
        modals_tabs.forEach(element => {
          let dataId = element.getAttribute('data-id');
          if(el.id == dataId) {
            element.classList.add('active');
            document.body.style.overflow = 'hidden';
          }
        })
      }
    })
  })
}

if(modals_tabs) {
  modals_tabs.forEach(el => {
    let close = el.querySelector('.product-modal-close');
    if(close) {
      close.addEventListener('click', () => {
        document.body.style.overflow = '';
        el.classList.remove('active');
      })
    }
    
    document.addEventListener('click', (e) => {
        if (e.target == el) {
          document.body.style.overflow = '';
          el.classList.remove('active');
        }
    });
  })
}

function initAccordions() {
  const answerPaddingTop = 0;
  const answerPaddingBottom = 0;

  const faqs = document.querySelectorAll(
    '.customer-service-accordion'
  );
  const buttons = document.querySelectorAll(
    '.customer-service-toggle'
  );
  const answers = document.querySelectorAll(
    '.customer-service-answer'
  );
  const answersHeightCalElements = document.querySelectorAll(
    '.customer-service-height-cal'
  );
  const icons = document.querySelectorAll(
    '.customer-service-arrow'
  );

  let activeIndex = -1;

  if(faqs.length > 0) {
     function openAnswer(index) {
      const height = answersHeightCalElements[index].offsetHeight;
  
      answers[index].style.display = 'block';
      setTimeout(() => {
        answers[index].style.paddingTop = `${answerPaddingTop}px`;
        answers[index].style.paddingBottom = `${answerPaddingBottom}px`;
        answers[index].style.height = `${height }px`;
        icons[index].style.setProperty('--rotate', '180deg');
      });
    }
    function closeAnswer(index) {
      answers[index].style.paddingTop = 0;
      answers[index].style.paddingBottom = 0;
      answers[index].style.height = 0;
      icons[index].style.setProperty('--rotate', '0deg');
  
      setTimeout(() => {
        answers[index].style.display = 'none';
      }, 300);
    }
    function toggleAnswer(index) {
      if (answers[index].style.display === 'none') {
        openAnswer(index);
        activeIndex = index;
      } else {
        closeAnswer(index);
        activeIndex = -1;
      }
    }
    function closeAllAnswerBut(index) {
      answers.forEach((answer, i) => {
        if (i !== index) {
          closeAnswer(i);
        }
      });
    }
  
    // When clicked, toggle the answer, animate the answer's height:
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        toggleAnswer(index);
        closeAllAnswerBut(index);
      });
    });
  
    // When the window is resized, debounce the answer's height:
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (activeIndex !== -1) {
          const height = answersHeightCalElements[activeIndex].offsetHeight;
          answers[activeIndex].style.height = `${height}px`;
        }
      }, 250);
    });
  
    openAnswer(0); 
  }
}

document.addEventListener('DOMContentLoaded', initAccordions);

let symbolToggleTabs = document.querySelectorAll('.symbol-toggle-tab');
let symbolTabs = document.querySelectorAll('.symbol-tab');
if(symbolToggleTabs) {
  symbolToggleTabs.forEach(el => {
    el.addEventListener('click', () => {
      symbolToggleTabs.forEach(element => {
        element.classList.remove('active');
      })
      el.classList.add('active');

      if(symbolTabs) {
        symbolTabs.forEach(element => {
          element.classList.remove('active');
          let dataId = element.getAttribute('data-id');
          if(dataId == el.id) {
            element.classList.add('active');
          }
        })
      }
    })
  })
}
let content = document.querySelector('.customer-service-text');
let list = document.querySelector('.customer-service-list');
if(content) {
  let headings = content.querySelectorAll('h2');
  if(headings) {
    headings.forEach(el => {
      const handle = el.textContent.toLowerCase().replace(/\W/g, "").replace(/\s+/g, "").replace(/(?:^|)(\w)/g, (_, c) => c.toLowerCase());
      el.setAttribute('id', handle );
      const listItem = document.createElement('li'); 
      listItem.classList.add('customer-service-list-item');
    
      const link = document.createElement('a'); 
      link.classList.add('article-link', 'header__menu-item', 'list-menu__item', 'link', 'link--text', 'focus-inset');
      link.setAttribute('href', "#" + handle);
      
      const span = document.createElement('span'); 
      span.textContent = el.textContent;
      
      link.appendChild(span); 
      listItem.appendChild(link);
      
      list.appendChild(listItem); 

      window.addEventListener('scroll', () => {
        let links = document.querySelectorAll('.article-link');
        const scrollPosition = window.scrollY || window.pageYOffset;

        const offsetTop = el.getBoundingClientRect().top + scrollPosition - 110;
        if (scrollPosition < headings[0].getBoundingClientRect().top + scrollPosition - 110) {
          links.forEach(link => link.classList.remove('active'));  
          links[0].classList.add('active');  
        } else {
          if (scrollPosition >= offsetTop) {
            links.forEach(link => link.classList.remove('active'));
            link.classList.add('active');  
          } else {
            link.classList.remove('active');
          } 
        }
      })
    }) 
    
  }
}

let firstLi = document.querySelectorAll('.product-modals-text li');
if(firstLi) {
  firstLi.forEach((el, index) => {
    if(index == 0) {
      el.addEventListener('click', () => {
        let modals = document.querySelectorAll('.product-modal');
        if(modals) {
          modals.forEach(element => {
            let dataId = element.getAttribute('data-id');
            if(dataId == "Shipping") {
              element.classList.add('active');
              document.body.style.overflow = 'hidden';
            }
          })
        }
      });
    } else if(index == 1) {
      el.addEventListener('click', () => {
        let modals = document.querySelectorAll('.product-modal');
        if(modals) {
          modals.forEach(element => {
            let dataId = element.getAttribute('data-id');
            if(dataId == "product-warranty-modal") {
              element.classList.add('active');
              document.body.style.overflow = 'hidden';
            }
          })
        }
      });
    } else if(index == 2) {
      el.addEventListener('click', () => {
        let modals = document.querySelectorAll('.product-modal');
        if(modals) {
          modals.forEach(element => {
            let dataId = element.getAttribute('data-id');
            if(dataId == "product-gift-modal") {
              element.classList.add('active');
              document.body.style.overflow = 'hidden';
            }
          })
        }
      });
    }
  })
}

setTimeout(() => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => { 
    anchor.addEventListener('click', function (e) { 
      e.preventDefault();
      const offset = 100;
      console.log(this.getAttribute('href'));
      const targetElement = document.querySelector(this.getAttribute('href'));
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
      
      window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
      });
    });
  });
  document.querySelectorAll('.article-link').forEach(el => {
  if(el) {
    el.addEventListener('click', () => {
      document.querySelectorAll('.article-link').forEach(element => {
        element.classList.remove('active');
      })
      el.classList.add('active');
    })
  }
})
}, 300); 

const element = document.querySelector('.product__info-container');
if(element) {
  const visibleHeight = element.clientHeight;
  const fullHeight = element.scrollHeight;
  const hiddenHeight = fullHeight - visibleHeight;
  console.log('Высота невидимой области: ' + hiddenHeight + 'px');

  stickybits('.product__column-sticky');
};

const selectElement = document.querySelector('.js-choice');
const choices = new Choices(selectElement, {
  searchEnabled: false,
  itemSelectText: '',
});

// syncScroll(document.querySelector('.product__media-wrapper'), document.querySelector('.product__info-wrapper'));

// function syncScroll(el1, el2) {
//   var el1 = el1;
//   var el2 = el2;
//   var forcedScroll = false;

//   el1.addEventListener('scroll', function() {
//     performScroll($el1, $el2);
//   });
//   el2.addEventListener('scroll', function() {
//     performScroll($el2, $el1);
//   });

//   function performScroll(scrolled, toScroll) {
//     if (forcedScroll) return (forcedScroll = false);
//     var percent = (scrolled.scrollTop /
//       (scrolled.scrollHeight - scrolled.offsetHeight)) * 100;
//     setScrollTopFromPercent(toScroll, percent);
//   }

//   function setScrollTopFromPercent(el, percent) {
//     var scrollTopPos = (percent / 100) *
//       (el.scrollHeight - el.offsetHeight);
//     forcedScroll = true;
//     el.scrollTop = scrollTopPos;
//   }
// }